import { IHospitalProps } from '@/entities/Hospital'
import { EmptyResponsePropsFactory, IResponseProps } from '@/entities/Response'

export interface IHospitalState {
  response: IResponseProps<IHospitalProps>
  current: IHospitalProps | null
  filter: string
}

export const state = (): IHospitalState => ({
  response: EmptyResponsePropsFactory(),
  current: null,
  filter: 'all'
})

export default state
